import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { BaseComponentConfig, ComponentConfig, ConfigOptions, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { FORMS } from './forms';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActivatedRoute, Router } from '@angular/router';
import { catalogOptions } from './configoptions';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs';

@Component({
  selector: 'ubs-catalog',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./catalog.component.scss']
})
export class CatalogComponent extends BaseComponentConfig implements OnInit {
  /* options:ConfigOptions = {
    name:"",
    title:"Catalog Component",
    appContext:"catalog",
    menuAndTitleOptions:{
      path:"catalogs",
      headerTitle:"Catalog Information",
      menuItems:[],
      menuTag:"catalogsMenu"
  },
    listForm:new OfbizList({
      listType:"grid",
      fieldFormName:"",
      fieldFormLocation:"local",
      listFormName:"ListCatalog",
      listFormLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
      columnFields:this.getFields("ListCatalog",FORMS),
      columnFieldTitles:this.getColumnFieldTitles("ListCatalog",FORMS),
      remoteFormData:{
        formData:{
          formName:"ListCatalog",
          formLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
          listType:"grid",
          viewIndex:1,
        },
        appContext:"catalog",
        parameters:{"noConditionFind":"Y"}
      },
      emptyListMessage:"No catalogs found.  Please create new store."
    }),
    findForm:new OfbizForm(),
    addForm:new OfbizForm({
      formName:"EditProdCatalog",
      formLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
      appContext:"catalog",
      fields:this.getFields("EditProdCatalog",FORMS),
      fieldSets:this.getFieldSets("EditProdCatalog",FORMS),
      targets:this.getTargets("EditProdCatalog",FORMS),
      titleDescriptionField:"catalogName",
      idFieldName:"prodCatalogId"
    }),
    actions:["list","find","add","edit"],
    breadCrumbData:{
      displayPrefix:"Catalogs",
      label:"",
      level:1,
      selectedValue:{
        "event":"list",
        "type":"ListProductStore",
        "data":{
          formData:{
            formName:"ListCatalog",
            formLocation:"component://kwikstore/widget/ProdCatalogForms.xml",
            listType:"grid"
          },
          "endPoint":""
        }
      },
      addFormText:"Create Product Catalog",
      editFormText:"Update Product Catalog"
    },
    settings:[],
    childComponent:new ComponentConfig({
      title:"Catalogs",
      listForm:new OfbizList({
        listType:"grid",
        fieldFormLocation:"local",
        listFormName:"ListCatalog",
        listFormLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
        columnFields:this.getFields("ListCatalog",FORMS),
        columnFieldTitles:this.getColumnFieldTitles("ListCatalog",FORMS),
        remoteFormData:{
          formData:{
            formName:"ListCatalog",
            formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            listType:"grid",

          },
          parameters:{"productStoreId":""}
        },
        emptyListMessage:"No catalogs found for this store.  Please add existing or create new."
      }),
      findForm:new OfbizForm(),
      addForm:new OfbizForm({
        local:true,
        formName:"EditProdCatalog",
        formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
        target:this.getTarget("EditProdCatalog",FORMS),
        targets:this.getTargets("EditProdCatalog",FORMS),
        fields:this.getFields("EditProdCatalog",FORMS),
        titleDescriptionField:this.getTitleDescriptionField("EditProdCatalog",FORMS),
        idFieldName:this.getIdFieldName("EditProdCatalog",FORMS),
      }),
      actions:["list","find","add","edit"],
      breadCrumbData:{
        displayPrefix:"Catalogs for ",
        label:"",
        level:2,
        selectedValue:{
          "event":"list",
          "type":"ListCatalog",
          "data":{
            formData:{
              formName:"ListCatalog",
              formLocation:"component://kwikstore/widget/StoreForms.xml",
            },
            "endPoint":""
          }
        },
        addFormText:"Create New Catalog",
        editFormText:"Update Catalog"
      },
      relations:[
        {
          title:"Roles",
          addContainerTitle:"Add Catalog Parties",
          listContainerTitle: "Edit Catalog Parties",
          keyMap:{fieldName:"prodCatalogId"},
          addFormName:"AddProdCatalogToParty",
          listFormName:"UpdateProdCatalogToParty",
          listForm:new OfbizList({
            listType:"grid",
            listFormName:"UpdateProdCatalogToParty",
            listFormLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            target:this.getTarget("UpdateProdCatalogToParty",FORMS),
            columnFields:this.getFields("UpdateProdCatalogToParty",FORMS),
            fieldFormFields:this.getFields("AddProdCatalogToParty",FORMS),
            columnFieldTitles:this.getColumnFieldTitles("UpdateProdCatalogToParty",FORMS),
            appContext:this.getAppContext("UpdateProdCatalogToParty",FORMS),
            emptyListMessage:"Found no people/organisations for this catalog. Please add exiting are create new."
          }),
          addForm:new OfbizForm({
            formName:"AddProdCatalogToParty",
            local:true,
            appContext:this.getAppContext("AddProdCatalogToParty",FORMS),
            targets:this.getTargets("AddProdCatalogToParty",FORMS),
            formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            fields:this.getFields("AddProdCatalogToParty",FORMS)
          })
        },
        {
          title:"Categories",
          addContainerTitle:"Add a Category to this Catalog",
          listContainerTitle:"    Edit Product Catalog Categories",
          keyMap:{fieldName:"prodCatalogId"},
          addFormName:"AddProductCategoryToProdCatalog",
          listFormName:"EditProdCatalogCategories",
          listForm:new OfbizList({
            listType:"grid",
            listFormName:"EditProdCatalogCategories",
            listFormLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            columnFields:this.getFields("EditProdCatalogCategories",FORMS),
            fieldFormFields:this.getFields("AddProductCategoryToProdCatalog",FORMS),
            appContext:"product",
            emptyListMessage:"No categories found for this catalog.  Please add existing or create new."
          }),
          addForm:new OfbizForm({
            formName:"AddProductCategoryToProdCatalog",
            local:true,
            appContext:this.getAppContext("AddProductCategoryToProdCatalog",FORMS),
            targets:this.getTargets("AddProductCategoryToProdCatalog",FORMS),
            formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            fields:this.getFields("AddProductCategoryToProdCatalog",FORMS)
          })
        }
      ],
      settings:[],
      
    }),
    outGoingLinks:[
      {
        target:"EditCategory",
        targetType:"",
        targetWindow:"",
        root:"categories",
        segments:[
          {pathElement:"categories",parameter:"prodCatalogId"},
          {pathElement:"category",parameter:"productCategoryId"}
        ],
        parameters:{},
        remoteFormData:{
          formData:{
            formName:"EditCategory",
            formLocation:"component://kwikstore/widget/CategoryForms.xml"
          }
        }
      }
    ]
  } */
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    configurationService:ConfigurationService,
    router:Router,
    private http:HttpClient,
    updateComponentStoreService:UpdateComponentStoreService,
    route:ActivatedRoute) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(catalogOptions);
  }

  ngOnInit(): void {
    this.baseUrl = this.getBaseUrl();
    let menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
    let menuTag = menuAndTitleOptions.menuTag;
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
    let menuItems:NbMenuItem[] = [
      {title:"List Catalogs",icon:"list-outline",link:"/admin/catalogs"},
      {title:"New Catalog",icon:"plus-outline"},
      {title:"Recent Catalogs",group:true,icon:"grid-outline"}
    ];
    this.getCatalogs(this.baseUrl).subscribe(resp => {
      let catalogs:any[] = [];
      let message = resp["successMessage"]
      if(message == "OK"){
        let data = resp["data"];
        let formData = data["formData"];
        let rows:any[] = formData.rows;
        console.log(rows);
        rows.forEach((row:any[]) => {
          let catalog:any = {};
          row.forEach(field => {
            for(let[k,v] of Object.entries(field)){
              catalog[k] = v;
            }
          })
          catalogs.push(catalog);
        })
        if(catalogs.length > 0){
          let _menuItems = this.createMenuItems(catalogs);
          console.log(_menuItems);
          menuItems = menuItems.concat(_menuItems);
        }
      }
      console.log(resp);
      this.menuService.addItems(menuItems,menuTag)
    })
    
  }

  getCatalogs(baseUrl:string){
    let url:string = baseUrl+'widgets/grid/value/ListCatalog?location=component://kwikstore/widget/ProdCatalogForms.xml';
    return this.http.get<any>(url).pipe(
      catchError(this.handleError),
      map(resp => resp)) 
  }

  createMenuItems(catalogs:any[]):NbMenuItem[]{
    let menuItems:NbMenuItem[] = [];
    catalogs.forEach((catalog,i) => {
      let prodCatalogId = catalog["prodCatalogId"];
      if(i < 6){
        let menuItem:NbMenuItem = {title:catalog["catalogName"]};
        menuItem.children = [
          {
            title:"Edit Catalog",
            link:"/admin/catalogs/catalog/"+prodCatalogId,
            icon:"edit-outline",
            data:{
              "event":"edit",
              "type":"EditProdCatalog",
              "label":"Edit Catalog "+prodCatalogId,
              "data":{
                formData:{
                  formName:"EditProdCatalog",
                  formLocation:"component://kwikstore/widget/ProdCatalogForms.xml"
                },
                appContext:"catalog",
                parameters:{prodCatalogId:prodCatalogId}
              },
            }
          },
          {
            title:"Categories",
            link:"/admin/catalogs/catalog/"+prodCatalogId,
            icon:"list-outline",
            data:{
              "event":"relate",
              "type":"Categories",
              "label":" Categories "+prodCatalogId,
              "data":{
                formData:{
                  formName:"EditProdCatalog",
                  formLocation:"component://kwikstore/widget/ProdCatalogForms.xml"
                },
                appContext:"catalog",
                parameters:{prodCatalogId:prodCatalogId}
              },
            }
          },
          {
            title:"Parties",
            link:"/admin/catalogs/catalog/"+prodCatalogId,
            icon:"people-outline",
            data:{
              "event":"relate",
              "type":"Parties",
              "label":"Parties "+prodCatalogId,
              "data":{
                formData:{
                  formName:"EditProdCatalog",
                  formLocation:"component://kwikstore/widget/ProdCatalogForms.xml"
                },
                appContext:"catalog",
                parameters:{prodCatalogId:prodCatalogId}
              },
            }
          },
          {
            title:"Stores",
            link:"/admin/catalogs/catalog/"+prodCatalogId,
            icon:"home-outline",
            data:{
              "event":"relate",
              "type":"Stores",
              "label":"Stores For: "+prodCatalogId,
              "data":{
                formData:{
                  formName:"EditProdCatalog",
                  formLocation:"component://kwikstore/widget/ProdCatalogForms.xml"
                },
                appContext:"catalog",
                parameters:{prodCatalogId:prodCatalogId}
              },
            }
          }
        ]
        menuItems.push(menuItem);
      }
    })
    return menuItems
  }
}
